// extracted by mini-css-extract-plugin
export default {"createFaqView":"CreateFaqArticle_createFaqView__VvJe8","actionButtons":"CreateFaqArticle_actionButtons__27wuK"};